import {ISection} from "../../model/B2CInfo";
import './InstagramItem.css'
import {useEffect, useRef, useState} from "react";
import {instance} from "../../../networking/axios";
import {AxiosResponse} from "axios";
import {Zones} from "../../zones/Zones";
import ReactList from 'react-list';
import InstagramPhoto from "./InstagramPhoto";
import {FixedSizeList} from "react-window";
import MobileInstagramPhoto from "./MobileInstagramPhoto";

interface IInstagramItemProps {
    section: ISection
    mobile: boolean
}

interface IInstagramPhotoContent {
    content: Array<IInstagramPhoto>
}

interface IInstagramPhoto {
    mds_preview_link: string
    short_link: string
}

export default function InstagramItem(props: IInstagramItemProps) {
    const [photos, setPhotos] = useState<Array<IInstagramPhoto> | undefined>(undefined)

    let ref = useRef(null)

    useEffect(() => {
        instance
            .get('/api/fake/instagram/info')
            .then((session: AxiosResponse<IInstagramPhotoContent>) => {
                let photos = session.data.content.slice(0, 20);
                photos.push(...session.data.content.slice(0, 20));
                setPhotos(photos)
            })
    }, [])

    if (props.mobile) {
        return <div className="Instagram_item_container_mobile">
            <div className="Instagram_item_container_title_mobile">
                Всегда есть на что посмотреть<br/>в нашем <a href="https://www.instagram.com/yndx.drive/?hl=ru" target="_blank">инстаграме</a>
            </div>
            <div className="Instagram_item_container_subtitle_mobile">
                Новости, запуски машин и обновления — там обо всём
            </div>
            {
                (photos != undefined) &&
                <div className="Instagram_photos_container_mobile">
                    {photos.map(
                        (photo, index) =>
                            index % 2 === 0 && (<MobileInstagramPhoto key={index}
                                                                      top={photos[index].mds_preview_link}
                                                                      bottom={photos[index + 1].mds_preview_link}/>))
                    }
                </div>
            }
        </div>
    } else {
        return <div className="Instagram_item_container">
            <div className="Instagram_item_container_header">
                <div className="Instagram_item_container_title">
                    Всегда есть на что посмотреть<br/>в нашем <a style={{color: "#241FFF"}}
                                                                 href="https://www.instagram.com/yndx.drive/?hl=ru" target="_blank">инстаграме</a>
                </div>
                <div className="Instagram_item_container_subtitle">
                    Новости, запуски машин и обновления — там обо всём
                </div>
            </div>
            {
                (photos != undefined) &&
                <div className="Instagram_photos_container">
                    {photos.map((photo) => <InstagramPhoto image={photo.mds_preview_link} shortLink={photo.short_link}/>)}
                </div>
            }
        </div>
    }
}